import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import CartPromoUpdate from '@/plugins/graphql/mutations/v2/cart-promo-update.gql';
import CartPromos from '@/plugins/graphql/queries/v2/cart-promos.gql';
import { successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import CartPromoDetails from '@/plugins/graphql/queries/v2/cart-promo.gql';
import CartPromoMixin from '@/helpers/vue_mixins/v2/ecommerce/CartPromoMixin';
import { CartPromoModel } from '@/helpers/entities/models/CartPromoModel';
import CartPromoForm from '@/components/v2/CartPromoForm.vue';
import { PromoType } from '@/helpers/entities/enums/v2/PromoType';
import { CartPromoProductInputModel } from '@/helpers/entities/models/CartPromoProductInputModel';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let CartPromoEdit = class CartPromoEdit extends mixins(AlertMixin, RouterParamsAppMixin, CartPromoMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.cartPromo = null;
    }
    get queryOnFlight() {
        return this.$apollo.queries.cartPromo.loading;
    }
    get formData() {
        const { cartPromo } = this;
        const data = {
            requiredAmount: null,
            promoType: PromoType.discount,
            discountType: null,
            value: null,
            freebies: [],
            paymentOptions: null,
        };
        if (cartPromo) {
            const { requiredAmount, promoType, discountType, value, products, paymentOptions, } = cartPromo;
            const freebies = products.map((product) => {
                return new CartPromoProductInputModel(product);
            });
            return {
                requiredAmount,
                promoType,
                discountType,
                value,
                freebies,
                paymentOptions,
            };
        }
        return data;
    }
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        await this.update(form)
            .then(() => {
            const msg = successfulUpdate('Cart Promo');
            this.cartPromoAction('SUBMIT EDIT');
            this.successNotification(msg);
            this.goToCartPromosPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async update(form) {
        const appUuid = this.appUUID;
        const { requiredAmount, promoType, discountType, value, paymentOptions } = form;
        const undeleted = (freebie) => {
            return !freebie.isDeleted;
        };
        const freebieUuids = form.freebies.filter(undeleted).map((freebie) => {
            return freebie.uuid;
        });
        this.$apollo.mutate({
            mutation: CartPromoUpdate,
            variables: {
                input: {
                    requiredAmount,
                    promoType,
                    discountType,
                    active: true,
                    value,
                    productUuids: freebieUuids,
                    cartPromoUuid: this.uuid,
                    paymentOptions,
                },
            },
            // update(cache: any, result: any) {
            //   const {
            //     data: {
            //       cartPromoUpdate: { cartPromo },
            //     },
            //   } = result;
            //   cache.writeFragment({
            //     id: cartPromo.uuid,
            //     fragment: CartPromoFragment,
            //     data: cartPromo,
            //     fragmentName: 'CartPromo',
            //   });
            // },
            refetchQueries: [
                {
                    query: CartPromos,
                    variables: {
                        appUuid,
                        first: 10,
                        after: null,
                    },
                },
            ],
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], CartPromoEdit.prototype, "uuid", void 0);
CartPromoEdit = __decorate([
    Component({
        components: {
            PageTitle,
            CartPromoForm,
        },
        apollo: {
            cartPromo: {
                query: CartPromoDetails,
                variables() {
                    const cartPromoUuid = this.uuid;
                    return {
                        cartPromoUuid,
                    };
                },
                update(data) {
                    return new CartPromoModel(data.fetchSpecificCartPromo);
                },
            },
        },
    })
], CartPromoEdit);
export default CartPromoEdit;
